import { Badge } from '../../ui';
import { useFieldContext } from '../FieldContext';
import { optionById } from '../fieldTypeMeta';
import { EmptyValue } from './EmptyValue';
import { TagDot } from './TagDot';

/** Two tags fit a phone-width cell; the rest become a count. */
const VISIBLE_TAGS = 2;

/**
 * ON A READ SURFACE EVERY OPTION IS TEXT WITH A DOT (`FieldContext.tagAsDot`). Same rule as
 * `SelectDisplay`, and it has to be the same rule: two options in one cell drawn as capsules
 * while the neighbouring SELECT column is text would be two answers to one question. The
 * `+n` overflow is the same either way: a row has room for two labels, not for eight.
 */
export function MultiSelectDisplay() {
  const { field, value, tagAsDot } = useFieldContext();
  if (!Array.isArray(value) || value.length === 0) {
    return <EmptyValue />;
  }
  const shown = value.slice(0, VISIBLE_TAGS);
  const hidden = value.length - shown.length;

  return (
    <span className="flex min-w-0 items-center gap-1">
      {shown.map((id) => {
        const option = optionById(field, id);
        return tagAsDot === true ? (
          <span key={id} className="list-value">
            {option?.color !== undefined && <TagDot tone={option.color} />}
            <span className="truncate">{option?.label ?? id}</span>
          </span>
        ) : (
          <Badge key={id} tone={option?.color ?? 'neutral'} size="sm">
            {option?.label ?? id}
          </Badge>
        );
      })}
      {hidden > 0 && (
        <span className="shrink-0 text-xs text-ink-subtle" title={value.join(', ')}>
          +{hidden}
        </span>
      )}
    </span>
  );
}
